import { render, staticRenderFns } from "./projectNotice.vue?vue&type=template&id=3cdad5e3&scoped=true"
import script from "./projectNotice.vue?vue&type=script&lang=js"
export * from "./projectNotice.vue?vue&type=script&lang=js"
import style0 from "./projectNotice.vue?vue&type=style&index=0&id=3cdad5e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdad5e3",
  null
  
)

export default component.exports